import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-primary-950 text-background-100 mt-16">
      <div className="w-full px-4 md:px-8 py-12 md:py-14">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8 md:gap-10">
          <div className="md:col-span-2">
            <div className="flex items-center gap-2">
              <span className="w-10 h-10 flex items-center justify-center rounded-lg bg-accent-500 text-background-50">
                <i className="ri-sparkling-2-fill text-xl"></i>
              </span>
              <span className="font-brand text-2xl text-background-50 leading-none">妖精动漫</span>
            </div>
            <p className="mt-4 text-sm leading-relaxed text-background-300 max-w-md">
              妖精动漫专注于提供丰富的动漫资源和最新动漫资讯，涵盖各类热门动漫作品，满足动漫爱好者的多样需求，方便用户在线浏览与了解动画动态。
            </p>
            <p className="mt-4 text-xs text-background-400">本站为内容展示演示站点，作品信息与评分为示例数据。</p>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4">快速导航</h4>
            <ul className="space-y-3 text-sm">
              <li><Link to="/" className="text-background-300 hover:text-accent-400 transition-colors cursor-pointer">首页</Link></li>
              <li><Link to="/category" className="text-background-300 hover:text-accent-400 transition-colors cursor-pointer">动漫分类</Link></li>
              <li><Link to="/news" className="text-background-300 hover:text-accent-400 transition-colors cursor-pointer">动漫资讯</Link></li>
              <li><Link to="/about" className="text-background-300 hover:text-accent-400 transition-colors cursor-pointer">关于我们</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4">关注我们</h4>
            <div className="flex items-center gap-3">
              <a href="https://zgsmwlw.cn" target="_blank" rel="noopener noreferrer" aria-label="微博" className="w-10 h-10 flex items-center justify-center rounded-lg bg-primary-900 text-background-200 hover:bg-accent-500 hover:text-background-50 transition-colors cursor-pointer">
                <i className="ri-weibo-fill text-lg"></i>
              </a>
              <a href="https://www.bilibili.com" target="_blank" rel="noopener noreferrer" aria-label="哔哩哔哩" className="w-10 h-10 flex items-center justify-center rounded-lg bg-primary-900 text-background-200 hover:bg-accent-500 hover:text-background-50 transition-colors cursor-pointer">
                <i className="ri-bilibili-fill text-lg"></i>
              </a>
              <a href="https://www.douban.com" target="_blank" rel="noopener noreferrer" aria-label="豆瓣" className="w-10 h-10 flex items-center justify-center rounded-lg bg-primary-900 text-background-200 hover:bg-accent-500 hover:text-background-50 transition-colors cursor-pointer">
                <i className="ri-douban-fill text-lg"></i>
              </a>
            </div>
            <p className="mt-4 text-sm text-background-300">
              <i className="ri-mail-line mr-1"></i>hello@yaojing-anime.demo
            </p>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-primary-900 flex flex-col sm:flex-row items-center justify-between gap-3 text-xs text-background-400">
          <p>© 2026 妖精动漫 · 保留所有权利</p>
          <p>内容仅供学习与演示使用</p>
        </div>
      </div>
    </footer>
  );
}